<template>
  <div class="container mt-5">
    <router-link class="float-right" to="/groups">
      <i class="fas fa-chevron-left"></i> Regresar
    </router-link>

    <h2 class="text-light">
      <i class="fas fa-users"></i> Crear Nuevo Grupo
    </h2>
    <form @submit.prevent="post()">
      <div class="row">
        <div class="col-md-8">
          <strong>Nombre:</strong>
          <input v-model="group.name" placeholder="nombre del grupo" type="text" class="form-control mb-3" required />
        </div>
      </div>
      <h2 class="text-light">Horarios</h2>
      <hr>
      <div class="row">
        <div class="col-md-4">
          <div class="m-4 text-light">
            <h4>Lunes</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.mondayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.mondayAm" :disabled="!hasSchedule.mondayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.mondayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.mondayPm" :disabled="!hasSchedule.mondayPm" class="form-control col-4" />
            </div>

            <h4 class="mt-4">Martes</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.tuesdayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.tuesdayAm" :disabled="!hasSchedule.tuesdayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.tuesdayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.tuesdayPm" :disabled="!hasSchedule.tuesdayPm" class="form-control col-4" />
            </div>

            <div class="row mt-5">
              <button class="btn btn-dark btn-lg" type="submit">
                Guardar
                <i class="fa fa-save"></i>
              </button>
              <router-link class="btn btn-dark btn-lg ml-3" to="/groups">
                Cancelar
                <i class="far fa-times-circle"></i>
              </router-link>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="m-4 text-light">
            <h4>Miércoles</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.wednesdayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.wednesdayAm" :disabled="!hasSchedule.wednesdayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.wednesdayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.wednesdayPm" :disabled="!hasSchedule.wednesdayPm" class="form-control col-4" />
            </div>

            <h4 class="mt-4">Jueves</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.thursdayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.thursdayAm" :disabled="!hasSchedule.thursdayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.thursdayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.thursdayPm" :disabled="!hasSchedule.thursdayPm" class="form-control col-4" />
            </div>
          </div>
        </div>
        
        <div class="col-md-4">
          <div class="m-4 text-light">
            <h4>Viernes</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.fridayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.fridayAm" :disabled="!hasSchedule.fridayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.fridayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.fridayPm" :disabled="!hasSchedule.fridayPm" class="form-control col-4" />
            </div>

            <h4 class="mt-4">Sábado</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.saturdayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.saturdayAm" :disabled="!hasSchedule.saturdayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.saturdayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.saturdayPm" :disabled="!hasSchedule.saturdayPm" class="form-control col-4" />
            </div>
            
            <h4 class="mt-4">Domingo</h4>
            <div class="row">
              <b-form-checkbox v-model="hasSchedule.sundayAm" switch size="lg" class="col-4">AM</b-form-checkbox>
              <input type="time" v-model="schedules.sundayAm" :disabled="!hasSchedule.sundayAm" class="form-control col-4" />
            </div>
            <div class="row mt-2">
              <b-form-checkbox v-model="hasSchedule.sundayPm" switch size="lg" class="col-4">PM</b-form-checkbox>
              <input type="time" v-model="schedules.sundayPm" :disabled="!hasSchedule.sundayPm" class="form-control col-4" />
            </div>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: this.$store.state.url,
      schoolId: this.$store.state.schoolId,
      group: {},

      //schedules
      hasSchedule: {
        mondayAm: false,
        mondayPm: false,
        tuesdayAm: false,
        tuesdayPm: false,
        wednesdayAm: false,
        wednesdayPm: false,
        thursdayAm: false,
        thursdayPm: false,
        fridayAm: false,
        fridayPm: false,
        saturdayAm: false,
        saturdayPm: false,
        sundayAm: false,
        sundayPm: false
      },
      schedules: {
        mondayAm: "",
        mondayPm: "",
        tuesdayAm: "",
        tuesdayPm: "",
        wednesdayAm: "",
        wednesdayPm: "",
        thursdayAm: "",
        thursdayPm: "",
        fridayAm: "",
        fridayPm: "",
        saturdayAm: "",
        saturdayPm: "",
        sundayAm: "",
        sundayPm: ""
      }
    };
  },
  methods: {
    async post() {
      try {
        this.group.schoolId = this.schoolId;
        let schedule = this.schedules

        if (!this.hasSchedule.mondayAm)
          delete schedule.mondayAm
        if (!this.hasSchedule.mondayPm)
          delete schedule.mondayPm

        if (!this.hasSchedule.tuesdayAm)
          delete schedule.tuesdayAm
        if (!this.hasSchedule.tuesdayPm)
          delete schedule.tuesdayPm
        
        if (!this.hasSchedule.wednesdayAm)
          delete schedule.wednesdayAm
        if (!this.hasSchedule.wednesdayPm)
          delete schedule.wednesdayPm

        if (!this.hasSchedule.thursdayAm)
          delete schedule.thursdayAm
        if (!this.hasSchedule.thursdayPm)
          delete schedule.thursdayPm
        
        if (!this.hasSchedule.fridayAm)
          delete schedule.fridayAm
        if (!this.hasSchedule.fridayPm)
          delete schedule.fridayPm
        
        if (!this.hasSchedule.saturdayAm)
          delete schedule.saturdayAm
        if (!this.hasSchedule.saturdayPm)
          delete schedule.saturdayPm

        if (!this.hasSchedule.sundayAm)
          delete schedule.sundayAm
        if (!this.hasSchedule.sundayPm)
          delete schedule.sundayPm

        let data = {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({group:this.group, schedule: schedule})
        };
        let req = await fetch(this.url + "group", data);
        if (req.ok) {
          this.$alert("Datos ingresados correctamente", "Ok", "success").then(
            () => this.$router.push("/groups")
          );
        }
      } catch (error) {
        this.$alert(error, "Ocurrió un error", "error");
      }
    }
  }
};
</script>

<style>
</style>